/* istanbul ignore file */
import React from 'react';
import { CREATE_ASSET } from 'domain/finance/assets/useAssetService';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { LinkButton } from 'framework/ui/ui-builder';

const CopyAssetButton = (props: { source?: string }) => {
  const { getCopyEntityUrl } = useAssetUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_ASSET) ? (
    <LinkButton variant="outlined" {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyAssetButton;
